if ((typeof Theme) === 'undefined') { Theme = {}; }

Theme.toggleAffix = function(affixElement, scrollElement, wrapper) {
  var height = affixElement.outerHeight(),
      top = wrapper.offset().top;

  if (scrollElement.scrollTop() >= top){
    wrapper.height(height);
    affixElement.addClass("affix");
  } else {
    affixElement.removeClass("affix");
    wrapper.height('auto');
  }
};

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
});

var contentCompareEles = [].slice.call(document.querySelectorAll('section.multicolumn .content-compare'));
if( contentCompareEles.length > 0 ){

  var contentCompares = contentCompareEles.map(function (containerEle) {
    let slider = containerEle;
    let before = containerEle.querySelector('.before');
    let beforeImage = before.getElementsByTagName('img')[0];
    let resizer = containerEle.querySelector('.compare-slider');
    let active = false;
    
    //Sort overflow out for Overlay Image
    document.addEventListener("DOMContentLoaded", function() {
      let width = slider.offsetWidth;
      beforeImage.style.width = width + 'px';
    });
    
    //Adjust width of image on resize 
    window.addEventListener('resize', function() {
      let width = slider.offsetWidth;
      beforeImage.style.width = width + 'px';
    })
    
    resizer.addEventListener('mousedown',function(){
     active = true;
     resizer.classList.add('resize');
    });
    
    document.body.addEventListener('mouseup',function(){
      active = false;
      resizer.classList.remove('resize');
    });
    
    document.body.addEventListener('mouseleave', function() {
      active = false;
      resizer.classList.remove('resize');
    });
    
    document.body.addEventListener('mousemove',function(e){
      if (!active) return;
      let x = e.pageX;
      x -= slider.getBoundingClientRect().left;
      contentCompareSlide(x);
      contentComparePause(e);
    });
    
    resizer.addEventListener('touchstart',function(){
      active = true;
      resizer.classList.add('resize');
    });
    
    document.body.addEventListener('touchend',function(){
      active = false;
      resizer.classList.remove('resize');
    });
    
    document.body.addEventListener('touchcancel',function(){
      active = false;
      resizer.classList.remove('resize');
    });
    
    //calculation for dragging on touch devices
    document.body.addEventListener('touchmove',function(e){
      if (!active) return;
      let x;
      let i;
      for (i=0; i < e.changedTouches.length; i++) { x = e.changedTouches[i].pageX; }
      x -= slider.getBoundingClientRect().left;
      contentCompareSlide(x);
      contentComparePause(e);
    });

    function contentCompareSlide(x){
      let transform = Math.max(0,(Math.min(x,slider.offsetWidth)));
      before.style.width = transform+"px";
      resizer.style.left = transform-0+"px";
    }
    
    //stop divs being selected.
    function contentComparePause(e){
      if(e.stopPropagation) e.stopPropagation();
      if(e.preventDefault) e.preventDefault();
      e.cancelBubble=true;
      e.returnValue=false;
      return false;
    }
    
  });
};

/* Enable Carousel on all sections */
jQuery('[data-slider-display]').each(function(index) {
  if(jQuery(this).length > 0 ) {
    var carouselDisplayType = jQuery(this).data('slider-display');
    if(carouselDisplayType == 'all' || ( carouselDisplayType == 'mobile' && (window.innerWidth < Shopify.mobile_breakpoint)) ) {
      jQuery(this).not('.slick-initialized').slick({
        slidesToShow: jQuery(this).data('slider-slides'),
        slidesToScroll: 1,
        arrows: jQuery(this).data('slider-arrows'),
        dots: jQuery(this).data('slider-dots'),
        infinite: jQuery(this).data('slider-infinite'),
        draggable: jQuery(this).data('slider-draggable'),
        adaptiveHeight: true,
        swipe: jQuery(this).data('slider-draggable'),
        responsive: [
          {
            breakpoint: Shopify.mobile_breakpoint,
            settings: {
              slidesToShow: jQuery(this).data('slider-slides')                                                                          
            }
          }
        ]
      });
    };
  };
});

/* Enable 'view more' on collection sections */
jQuery('.collection .product-grid').each(function() {
  var items_to_show = parseInt(jQuery(this).data('list-limit')); // index starts at zero
  var total_items = jQuery(this).find('> div').length;
  var view_more_button = jQuery(this).parent().find('.view-more-button:not([href])');
  
  if( items_to_show < total_items && view_more_button.length > 1 ) {
    items_to_show = items_to_show - 1;
    view_more_button.show();
    jQuery(this).find('> div:gt('+items_to_show+')').hide();
    jQuery(this).show();
    
    view_more_button.click(function () {
      var list_target = '.grid-'+jQuery(this).data('list-id');
      jQuery(list_target+' div').show();
      jQuery(this).hide();
    });
  };
});

/* NAVIGATION */
if( window.innerWidth > 1200 ) {
  jQuery(".navbar-nav.tier-1 > .dropdown").hover(
    function(){ jQuery(".navbar-nav.tier-1 .dropdown").removeClass('open'); jQuery(this).addClass('open'); jQuery('main').prepend('<div class="mainNavOverlay"></div>'); },
    function(){ jQuery(this).removeClass('open'); jQuery('div.mainNavOverlay').not('.cart').remove(); }
  );
  jQuery(".dropdown-toggle").click( function() {
    window.location = jQuery(this).attr('href');
  });

} else {
  let menu = jQuery('.navbar-nav.tier-1');

  jQuery('.navbar-toggler').on('click', function (evt) {
    menu.removeClass('open');
    menu.find('.dropdown.open').removeClass('open');
  });

  jQuery('.navbar-nav.tier-1 > .dropdown > .dropdown-toggle').on('click', function (evt) {
    evt.preventDefault();
    if( parseInt(menu.css('left')) == 0 ) { 
      jQuery(this).parent().toggleClass('open');
      menu.addClass('open');
    }
  });

  jQuery('.navbar-nav.tier-2 > .dropdown').on('click', function () {
    jQuery(this).siblings().removeClass('open');
    jQuery(this).toggleClass('open');
  });

  jQuery('a.menu-back').on('click', function () { 
    menu.removeClass('open');
    menu.find('.dropdown.open').removeClass('open');
    jQuery(this).parent().parent().focusout();
  });

} // if( parseInt(jQuery(window).width()) > 768 )
/* END NAVIGATION */